import { faXmark } from "@fortawesome/pro-solid-svg-icons";
import {
  FontAwesomeIcon,
  type FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

const CloseIcon = ({ ...props }: Omit<FontAwesomeIconProps, "icon">) => (
  <FontAwesomeIcon icon={faXmark} {...props} title={undefined} />
);

export { CloseIcon };
